import { IRequestParams, IResponse } from '@dash/apiInstance';
import { all, call, put, takeEvery } from 'redux-saga/effects';
import { sendRequest } from 'src/helpers/saga';
import { executeAction } from 'src/helpers/api';
import { push } from 'redux-first-history';
import actions from './actions';
import { logger } from '../../../../../helpers/logger';
import { t } from '../../../../../i18n';
import notifications from '../../../../../redux/notifications/actions';
import actionTypes from './actionTypes';
import { ProcessActionRequestAction } from './actions.d';
import { IProcessActionResponse } from './types';
import skillsActions from '../actions';
import landingPageSkillsActions from '../../../../landingPage/newSkillsApplications/actions';

function* processAction({ payload }: ProcessActionRequestAction<{}, {}>) {
  try {
    const { url, method, data, key, id, isLandingPage, loadSkillsQuery } = payload;

    const result: IResponse<IProcessActionResponse> = yield call<any, IRequestParams<{}, {}>, string>(
      sendRequest,
      executeAction,
      { url, method, data },
      notifications.REQUEST_ERROR,
    );

    if (result?.status === 200) {
      // @ts-ignore
      const newQueryParams = new URLSearchParams(loadSkillsQuery || {}).toString();
      const currentPath = window.location.pathname;

      switch (key) {
        case 'approve':
          yield put(
            notifications.addNotification({
              headline: t('dash.common.notification.success_headline'),
              type: 'success',
              message: t('dash.landingPage.newSkillsApplications.skill_approved_successful_text'),
            }),
          );

          yield put(actions.changeModalVisibility({}));

          if (isLandingPage) {
            // @ts-ignore
            yield put(landingPageSkillsActions.loadSkillApplicationsRequest(loadSkillsQuery));
            yield put(push(`${currentPath}?${newQueryParams}`));
          } else {
            yield put(skillsActions.loadPendingSkillsRequest({ id }));
            yield put(skillsActions.loadActiveSkillsRequest({ id }));
          }

          break;
        case 'deny':
          yield put(
            notifications.addNotification({
              headline: t('dash.common.notification.success_headline'),
              type: 'success',
              message: t('dash.landingPage.newSkillsApplications.skill_denied_successful_text'),
            }),
          );

          yield put(actions.changeModalVisibility({}));

          if (isLandingPage) {
            // @ts-ignore
            yield put(landingPageSkillsActions.loadSkillApplicationsRequest(loadSkillsQuery));
            // @ts-ignore
            yield put(push(`${currentPath}?${newQueryParams}`));
          } else {
            yield put(skillsActions.loadPendingSkillsRequest({ id }));
            yield put(skillsActions.loadDeniedSkillsRequest({ id }));
          }

          break;
        case 'view_skill':
          // @ts-ignore
          yield put(actions.processActionSuccess({ skillDetails: result?.data?.success?.data, key }));

          break;
        default:
          yield put(
            notifications.addNotification({
              headline: t('dash.common.notification.success_headline'),
              type: 'success',
              message: result?.messages?.join(' ') || '',
            }),
          );
          break;
      }
    } else {
      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.error_headline'),
          type: 'error',
          message: t('dash.common.notification.something_went_wrong'),
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actionTypes.PROCESS_ACTION_REQUEST, processAction)]);
}
